import api from '../../utils/api'

export const state = {}

export const mutations = {}

export const actions = {
  async handleGetByTagEmailAutomationId(_, payload) {
    try {
      const {
        tagEmailAutomationId, page, limit, email, status
      } = payload || {}
      const params = {
        page: page || undefined,
        limit: limit || undefined,
        email: email || undefined,
        status: status || undefined
      }
      const { data } = await api.get(`/tag-email-automation-sent-log/${tagEmailAutomationId}`, { params })
      return data
    } catch (e) {
      // silent
    }
  }
}

export const getters = {}
